export default from './GlobalHeader.js';



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/index.js